import React from 'react';
import './App.css';

import Navigation from './pages/Navigation';
import { DataProvider } from './context/DataProvider';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
const {REACT_APP_STRIPE_PUBLISHABLE_KEY} = process.env
const stripePromise = loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY)

class App extends React.Component {

  render() {
    return (
     <Elements stripe={stripePromise}>
       <PayPalScriptProvider options={{ "client-id": "AXers_uAI1uA-Xt_l2WKwMq3g37KXt6jJBZvG3uUsRVJXRMwIhuSlfn2JBLd-lKx4M2gnE7iLbC2LpnW", currency:"USD" }}>
        <DataProvider>
          <Navigation/>
        </DataProvider>
        </PayPalScriptProvider>
       </Elements> 
    );
  }
}

export default App;
